<template>
  <div class="p-5">
    <div class="flex h-full w-full mx-auto py-4 bg-white rounded-lg shadow-md">
      
      <div
        :class="isSidebarOpen ? 'w-64' : 'w-20'"
        class="ml-8 rounded-md bg-blue-800 p-3 text-white transition-all duration-300 ease-in-out"
      >
        <div class="flex items-center justify-between">
          <div class="text-2xl font-bold tracking-wider" v-show="isSidebarOpen">
            MINPOSTEL
          </div>
          <button class="text-xl pl-4" @click="toggleSidebar">&#9776;</button>
        </div>
        <nav class="mt-10">
          <a
            href="#"
            @click="displayContactOnly ? displayContact() : null"
            class="flex justify-start items-center py-2.5 px-4 rounded transition duration-200 hover:bg-blue-700"
          >
            <i class="fas fa-home pr-4"></i>
            <span v-show="isSidebarOpen" class="text-white font-bold " >Missions</span>
          </a>
          <a
            href="#"
            @click="displayContact()"
            class="flex justify-start items-center py-2.5 px-4 rounded transition duration-200 hover:bg-blue-700"
          >
            <i class="fas fa-phone pr-4"></i>
            <span class="text-white font-bold " v-show="isSidebarOpen">Contact Us</span>
          </a>
          <a
            href="#"
            class="flex justify-start items-center py-2.5 px-4 rounded transition duration-200 hover:bg-blue-700"
          >
            <i class="fas fa-image pr-4"></i>
            <span class="text-white font-bold " v-show="isSidebarOpen">Gallery</span>
          </a>
          <a
            href="#"
            class="flex justify-start items-center py-2.5 px-4 rounded transition duration-200 hover:bg-blue-700"
          >
            <i class="fas fa-office pr-4"></i>
            <span class="text-white font-bold " v-show="isSidebarOpen"> Regional </span>
          </a>
          <a
            href="#"
            @click="created()"
            class="flex justify-start items-center py-2.5 px-4 rounded transition duration-200 hover:bg-blue-700"
          >
            <i class="fas fa-office pr-4"></i>
            <span class="text-white font-bold " v-show="isSidebarOpen"> View </span>
          </a>

          <!-- More sidebar items... -->
        </nav>
      </div>

      <!-- Main Content -->
      <main class="flex-1 mx-5">
        <div class="" v-for="sector in allStructures" :key="sector.id">
          <div  v-show="!displayContactOnly" class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <!-- About Us Section -->
            <div class="md:col-span-2">
              <div>
                <img class="w-full" :src="sector.structure_image" alt="" />
                <h2 class="text-2xl text-left font-bold my-2 text-blue-800">
                  {{ sector.structure_name }}
                </h2>

                <div class="text-left">
                  <h3 class="text-lg text-left font-bold my-1 text-blue-800">
                    About Us
                  </h3>
                  <hr />
                  <p class="text-gray-700 mb-4">
                    The ministry of post and telecommunication is responsible
                    for implementing the government policy in regards to post,
                    telecommunication and information and communication
                    technologies.
                    <a href="#" class="text-blue-600 hover:underline">more</a>
                  </p>
                </div>
              </div>

            </div>

            <!-- The Minister Information Card -->
            <div class="flex flex-col items-center p-8 bg-blue-500 rounded-lg">
              <h1 class="text-lg text-left font-bold my-1 text-white">
                The Minister
              </h1>

              <div
                class="bg-white w-full flex flex-col items-center p-4 rounded-lg"
                style="display: flex; justify-content: flex-start;"
              >
                <img
                  class="w-24 h-24 rounded-full mb-3"
                  src="\assets\images\avatar.png"
                  alt="Mme. LIBOM LI LIKENG"
                />
                <h3 class="text-lg font-semibold mb-2">{{sector.director_name}}</h3>
                <ul class="">
                  <li class="flex justify-between items-center mb-1">
                    <img src="\assets\images\facebook.png" alt="" />
                    <a
                      href="https://web.facebook.com/"
                      class="ml-2 text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer"
                      >
                      <div>
                        <p v-if="sector.director_facebook_url.length !== 0">{{ sector.director_facebook_url }}</p>
                        <p v-else>No Accounts</p>
                      </div>
                      
                      </a
                    >
                  </li>
                  <li class="flex justify-between items-center mb-1">
                    <img src="\assets\images\twittter.svg" alt="" />
                    <a
                      href="https://twitter.com/"
                      class="ml-2 text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer"
                      >
                      <div>
                        <p v-if="sector.director_twitter_url.length !== 0">{{ sector.director_twitter_url }}</p>
                        <p v-else>No Accounts</p>
                      </div>
                      
                  </a
                    >
                  </li>
                  <li class="flex justify-between items-center">
                    <img src="\assets\images\mail.svg" alt="" />
                    <a
                      href="mailto:contactus@minfi.cm"
                      class="ml-2 text-blue-600 hover:underline"
                      >
                      <div>
                        <p v-if="sector.director_email.length !== 0">{{ sector.director_email }}</p>
                        <p v-else>No Accounts</p>
                      </div>
                      
                    
                      </a
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- //Contact us  -->

          <div>
            <h3 class="text-lg text-left font-bold my-1 text-blue-800">
              Contact Us
            </h3>
            <hr />
            <div class="flex w-full space-x-4 justify-between">
              <ul 
              class="w-full "
              >
                <li class="flex items-center mb-1 p-3 rounded-lg bg-blue-500">
                  <i class="fas fa-globe"></i>
                  <a
                    href="https://minfi.gov.cm/"
                    class="ml-2 text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer"
                    >{{ sector.website_url }}</a
                  >
                </li>
                <li class="flex items-center mb-1 p-3 rounded-lg bg-blue-500">
                  <i class="fab fa-facebook-f"></i>
                  <a
                    href="https://web.facebook.com/"
                    class="ml-2 text-white hover:underline" target="_blank" rel="noopener noreferrer"
                    >{{ sector.facebook_url }}</a
                  >
                </li>
                <li class="flex items-center mb-1 p-3 rounded-lg bg-blue-500">
                  <i class="fab fa-twitter"></i>
                  <a
                    href="https://web.facebook.com/"
                    class="ml-2 text-white hover:underline" target="_blank" rel="noopener noreferrer"
                    >{{ sector.twitter_url }}</a
                  >
                </li>
                <li class="flex items-center mb-1 p-3 rounded-lg bg-blue-500">
                  <i class="far fa-envelope"></i>
                  <a
                    href="https://web.facebook.com/"
                    class="ml-2 text-white hover:underline" target="_blank" rel="noopener noreferrer"
                    >{{ sector.email }}</a
                  >
                </li>
              </ul>
              <ul
              class="w-full "
              >
                <li class="flex items-center mb-1 p-3 rounded-lg bg-blue-500">
                  <i class="fas fa-phone"></i>
                  <a
                    href="https://minfi.gov.cm/"
                    class="ml-2 text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer"
                    >{{ sector.phone }}</a
                  >
                </li>
                <li class="flex items-center mb-1 p-3 rounded-lg bg-blue-500">
                  <i class="fas fa-map-marker-alt"></i>
                  <a
                    href="https://web.facebook.com/"
                    class="ml-2 text-white hover:underline" target="_blank" rel="noopener noreferrer"
                    >{{ sector.location }}</a
                  >
                </li>
                <li class="flex items-center mb-1 p-3 rounded-lg bg-blue-500">
                  <i class="fas fa-directions"></i>
                  <a
                    href="https://web.facebook.com/"
                    class="ml-2 text-white hover:underline" target="_blank" rel="noopener noreferrer">    
                         <google-map :center="center" :zoom="zoom">
                         <google-marker :position="markerPosition"></google-marker>
                         </google-map>
                  </a
                  >
                </li>
                <li class="flex items-center mb-1 p-3 rounded-lg bg-blue-500">
                  <i class="fas fa-home"></i>
                  <a
                    href="https://web.facebook.com/"
                    class="ml-2 text-white hover:underline" target="_blank" rel="noopener noreferrer"
                    >Regionals</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>

</template>

<script>
import axios from 'axios'
const BaseURL = process.env.VUE_APP_API_BASE_URL;
export default {
  name: "SectorPage",

  data() {
    return {
      isSidebarOpen: true,
      displayContactOnly:false,
      allStructures:[],
      itemId :this.$route.params.id,
      SectorId:1,
      YOUR_LATITUDE:12,
      YOUR_LONGITUDE:10,
      center: { lat: this.YOUR_LATITUDE, lng: this.YOUR_LONGITUDE },
      zoom: 10,
      markerPosition: { lat: this.YOUR_LATITUDE, lng: this.YOUR_LONGITUDE },
    };
  },

  created(){
    location.reload();
    this.SectionId= this.$router.params.sectorId
  },
  beforeRouteUpdate(to, from, next) {
    // Check if the ID parameter has changed
    if (to.params.id !== from.params.id) {
      // Perform any necessary actions, such as fetching data using the new ID
      this.fetchData(to.params.id)
    }

    // Call next() to continue with the component update
    next()
  },

  watch: {
    '$i18n.locale'() {
      if (this.SectorId) {
        this.fetchData(this.SectorId);
      }
    }
  },

  methods: {
    toggleSidebar() {
      this.isSidebarOpen = !this.isSidebarOpen;
      
    },
    displayContact() {
      this.displayContactOnly = !this.displayContactOnly;
    },

    getStructure(){
      this.created()
      this.beforeRouteUpdate()
      axios.get(`${BaseURL}/structures/${this.SectorId}`)
      .then(response => {
        this.YOUR_LATITUDE=response.data.results.latitude
        this.YOUR_LONGITUDE=response.data.results.longitude

        if (response.data.results.length > 0) { 
          this.allStructures = response.data.results;
        } 
        })
    }
  },
};
</script>

<style>
/* Add any additional styles here if needed */
</style>
